type Props = {
    name: string
    title: string
    image: string
    quote: string
  }
  
  export const TestimonialCard = ({ name, title, image, quote }: Props) => {
    return (
      <div>
        <div className="hidden lg:block">
          <div className="bg-[#F6EEEE] rounded-[28px] px-12 py-8 shadow-sm border border-white pointer-events-none  w-[635px] h-[280px] grid items-start">
  
        <div className="flex items-center gap-4 mb-6">
  
          <img
            src={image}
            alt={name}
            className="w-[64px] h-[64px] rounded-full object-cover"
          />
  
          <div>
            <h4 className="font-semibold text-[18px] text-gray-900">
              {name}
            </h4>
  
            <p className="text-gray-500 text-[14px]">
              {title}
            </p>
          </div>
  
        </div>
  
        <div className="flex gap-4">
  
          <span className="text-red-600 text-[40px] leading-none">“</span>
  
          <p className="text-[18px] text-gray-800 leading-relaxed">
            {quote}
          </p>
  
        </div>
  
      </div>
        </div>

        <div className="block lg:hidden">
          <div className="bg-[#FFFFFF] rounded-[28px] p-8 shadow-sm border border-white w-[360px] h-[250px]">
  
        <div className="flex items-start gap-4 mb-6">
  
          <img
            src={image}
            alt={name}
            className="w-[34px] h-[34px] rounded-full object-cover"
          />
  
          <div>
            <h4 className="text-start font-semibold text-[14px] text-gray-900">
              {name}
            </h4>
  
            <p className="text-start text-gray-500 text-[12px]">
              {title}
            </p>
          </div>
  
        </div>
  
        <div className="flex gap-4">
  
          <span className="text-red-600 text-[20px] leading-none">“</span>
  
          <p className="text-start text-[12px] text-gray-800 leading-relaxed">
            {quote}
          </p>
  
        </div>
  
      </div>
        </div>
      </div>
      
    )
  }